export default __webpack_public_path__ + "static/meshery_initial_load_test-c6073960354f300204944cda56099c66.webp";